import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HandleResponseError } from '../../shared/functions/shared-functions';
import {CoreService} from "../../services/core.service";
import {secureStorage} from "../../shared/functions/secure-storage";

@Injectable({
    providedIn: 'root'
})
export class SharedSystemsGuard implements CanActivate {
    constructor(
        private toastr: ToastrService,
        private coreService: CoreService
    ) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if (secureStorage?.getItem('shared_token')) {
            return true;
        } else {
            return await this.login();
        }
    }

    async login(): Promise<boolean> {
        const body = secureStorage.getItem('user_cred');
        try {
            const res: any = await this.coreService.postRequest('KseKuwait/api/User/LogIn', body, {}, true, false).toPromise();
            secureStorage.setItem('shared_token', res.token);
            return true;
        } catch (error) {
            this.toastr.error(HandleResponseError(error));
            return false;
        }
    }
}
